// Modulo de busqueda de sku's
import React , { useState }from 'react'


import Form from 'react-bootstrap/Form';

import {faMagnifyingGlass} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown'

import axios from 'axios';
//import getGlobal from '../../setglobal';
import SearchDrop from './SearchDrop';
import SearchDropUnidad from './SearchDropUnidad';


export default function SearchUnidad({show ,setClaveProd , setUnidad}) {

    const [showDrop,setShowDrop] = useState( false ) ;
    const [myData, setMyData] = useState( []) ;
    const [showIcon,setShowIcon] = useState( true ) ;


    function onEnterInput()
    {
        console.log( "onEnterInput")
        setShowIcon( true ) ;
    }

    function onLeaveInput()
    {
        console.log("onLeaveInput")
        setShowIcon( false ) ;
    }


    function setClave( value )
    {
        console.log( "Value = " + value ) ;

        setClaveProd( value ) ; 
    }

    function onSearchSku(e)
    {
        e.preventDefault() ;

        var sku = document.getElementById( 'buscar').value ;
        console.log( "Nos mandan a buscar " + sku ) ;


        var prodList = sku.split( " ") ;


        axios.get(  "http://localhost:3004/livefactura/getunidad?parms=" + prodList )
        .then( (response) => {


            console.log( "Aqui tenemos la respuesta") ;

            console.log( response.data ) ;

            setMyData( response.data ) ;
            if ( response.data.length > 0 )
            {
                setShowDrop( true ) ;
            }
            else{
                setShowDrop ( false ) ;
            }
            

        } ) 
        .catch( ( err ) => {

            console.log( "Tenemos un error")
            console.log( err ) ;
        })





        
    }

    function onChangeSku( e )
    {


        return ; // No lo hacemos en tiempo real
        

        //document.getElementById( 'buscar').value = "supertools";
    }

  return (

    //<div>Hola amigo</div>

    <div className='search' id="searchform">
        
        <div className='row pt-2 '>
            <div className='col-4'></div>
            <div className='col-4'>
                <div style={{display:'flex' , position:'relative'}}>
                    <Form.Control
                        type="text"
                        id="buscar"
                        aria-describedby="buscarBlock"
                        placeholder='Unidad'
                        height={20}
                        onChange={onChangeSku}
                        // onMouseEnter={onEnterInput}
                        // onMouseLeave={onLeaveInput}
                    />
                    <Form.Text id="buscarBlock" >
                    </Form.Text> 
                    { showIcon && (
                        <FontAwesomeIcon onClick={onSearchSku}  className='pt-2' style={{height:'25px', position:'absolute' , right :'5px' }} icon={faMagnifyingGlass} />

                    )

                    }               

                </div> 

                {showDrop && (<SearchDropUnidad myData={myData} setUnidad={setUnidad} show={show} setClaveProd={setClave}></SearchDropUnidad>)}

                
            </div>
            <div className='col-1 '>
                {/* <Button ></Button> */}
                

               
            </div>

            
        
        </div>
    
      {/* <Form.Label htmlFor="inputPassword5">Password</Form.Label> */}

    </div>
  )
}
